import React from "react";
import { Redirect, Route } from "react-router-dom";

function AuthRoute({ component: Component, ...restOfProps }) {
    const isAuthenticated = localStorage.getItem("accessToken");
    return (
        <Route
            {...restOfProps}
            render={(props) =>
                isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
            }
        />
    );
}

export default AuthRoute;